import React, { useCallback, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CarouselV2 from '~shared/ui/CarouselV2/CarouselV2';
import { ssDispatch } from '~SpectateStore';
import {
    useSelectedMarketTab,
    useMarketsGroupsByEventId,
} from '~SpectateStore/hooks/eventsHooks';
import { updateSelectedMarketGroup } from '~SpectateStore/slices/eventsSlice';
import './styles/marketGroupTabs.scss';

const MarketsGroupTabs = ({ eventId }) => {
    const [ t ] = useTranslation();
    const selectedTab = useSelectedMarketTab(eventId);
    const marketsGroups = useMarketsGroupsByEventId(eventId);

    useEffect(() => {
        const groupFromUrl = location.hash.replace('#', '');
        if (groupFromUrl) {
            ssDispatch(updateSelectedMarketGroup({eventId, slug: groupFromUrl}));
        }
    }, []);

    const onChangeMarketGroup = (group) => {
        ssDispatch(updateSelectedMarketGroup({eventId, slug: group.slug}));
        window.history.replaceState(null, null, `${location.href.replace(location.hash, '')}#${group.slug}`);
    };

    const changeOption = useCallback((option) => () => onChangeMarketGroup(option), [onChangeMarketGroup]);

    const marketTabs = marketsGroups.map(group => {

        return <div
            key={group.slug}
            data-hash={group.slug}
            onClick={changeOption(group)}
            className={classNames({'active': group.slug === selectedTab}, 'markets-groups__tab')}
        >
            {t(`inplay.${group.slug.replace(/-/g, '_')}`, group.name)}
        </div>;
    }
    );

    if (!marketsGroups || marketsGroups.length <= 1) {
        return null;
    }

    return (
        <CarouselV2
            jsxItems={marketTabs}
        />
    );
};

MarketsGroupTabs.propTypes = {
   eventId: PropTypes.string,
};

export default MarketsGroupTabs;
